export const maxRoofAgeAllowed = {
  OH: 200 // this is set to 200 so we can keep this ability to limit roof age for now
  // (it's not intended to actually limit roof age)
};

export const overrideHomeRoofTypeWithCherreStates = {
  AR: true,
  AZ: true,
  DC: true,
  FL: true,
  GA: true,
  IA: true,
  IL: true,
  IN: true,
  KY: true,
  LA: true,
  MD: true,
  MI: true,
  MO: true,
  MS: true,
  MT: true,
  ND: true,
  NE: true,
  NM: true,
  OH: true,
  OK: true,
  OR: true,
  PA: true,
  TX: true,
  UT: true,
  WI: true,
  WV: true
};

export const allowFlatRoofCoverageByState = {
  AZ: {
    roofAgeMax: 10,
    deductibleWindHailMin: 0.01
  },
  NM: {
    roofAgeMax: 10,
    deductibleWindHailMin: 0.01
  }
};

export const unsupportedRoofMaterialTypes = ['RR', 'BUP', 'SPF'];

export const allowUnsupportedRoofMaterialStates: Record<string, boolean> = {
  AZ: true,
  NM: true
};

export const enhancedRoofWindstormStates = { SC: true, LA: true };

/**
 *
 * @description states with expanded roof types (ie. SL, WD)
 */
export const expandedRoofTypeStates = {
  DC: true,
  ME: true,
  ND: true,
  NH: true,
  SD: true,
  VT: true
};

/**
 *
 * @description states with coverageRSExtended always set to true
 */
export const coverageRSExtendedForcedStates = {
  DC: true,
  NH: true,
  NM: true,
  VT: true,
  WV: true
};

/**
 *
 * @description states with coverageRSExtended always set to false, essentially forcing basic coverage regardless of roof age
 */
export const coverageRSForcedStates = {};

/**
 *
 * @description states with coverageRSExtended can be true or false, no roof age limit
 */
export const coverageRSNoLimitsStates = {
  MD: true,
  MI: true,
  MS: true
};

/**
 *
 * @description states with coverageRSExtended selector disabled
 */
export const coverageRSEDisabledStates = {
  AR: true,
  GA: true
};

export const coverageRSLabelStates = {
  DC: 'Roof Surfaces',
  ME: 'Roof Surfaces',
  NH: 'Roof Surfaces',
  ND: 'Roof Surfaces',
  SD: 'Roof Surfaces',
  VT: 'Roof Surfaces'
};

/**
 *
 * @description states that use extendedCoverageRSLimitsNonCW and roofMaterial to calculate coverageRSExtended
 */
export const extendedCoverageRSByRoofMaterialNonCWStatesList = ['ND', 'LA'];

/**
 *
 * @description roof age limit for coverageRSExtended by roof material non CW state rules
 */
export const extendedCoverageRSLimitsNonCW = {
  W: 10,
  C: 15,
  M: 20,
  S: 20,
  T: 20,
  O: 10
};

/**
 *
 * @description roof age limit for coverageRSExtended by roof material for CW state rules
 */
export const extendedCoverageRSLimitsCW = {
  W: 15,
  C: 15,
  M: 20,
  S: 15,
  T: 20,
  O: 15
};

/**
 *
 * @description states that will not calculate roof age limit depending on its material
 */
export const extendedCoverageRSByRoofMaterialStateExclusions = [
  'AR',
  'DC',
  'GA',
  'MA',
  'MD',
  'MI',
  'ME',
  'NM',
  'NH',
  'OK',
  'TX',
  'VA',
  'VT',
  'WV'
];

/**
 *
 * @description states that will not have their roof extended coverage expired
 */
export const extendedCoverageRSExpirationByAgeStateExclusions = {
  DC: true,
  MD: true,
  MI: true,
  NM: true,
  WV: true
};

export const coverageRSDescriptionStates = {
  DC: 'Coverage for roof surfaces up to repair/replacement cost',
  ME: 'Coverage for roof surfaces up to repair/replacement cost. If you do not purchase this, roof claims will be handled with a payment schedule.',
  NH: 'Coverage for roof surfaces up to repair/replacement cost',
  ND: 'Coverage for roof surfaces up to repair/replacement cost',
  SD: 'Coverage for roof surfaces up to repair/replacement cost. If you do not purchase this, roof claims will be handled with a payment schedule.',
  VT: 'Coverage for roof surfaces up to repair/replacement cost'
};

// special states where the option is binary, either force extended or schedule based on roofAge higher/lower than value
export const noShowRoofSurfacesExtendedUnderXYearsStates = {
  GA: 15,
  AR: 7
};

// Note that this gets overridden if the roof age limit for the roof type in this state
// is higher than the coverageRSForcedAtXYearsStates value
export const coverageRSForcedAtXYearsStates = {
  AL: 15,
  AR: 7,
  AZ: 15,
  CO: 15,
  GA: 15,
  IA: 15,
  ID: 15,
  IL: 15,
  IN: 15,
  KS: 15,
  KY: 15,
  LA: 15,
  MA: 15,
  MD: 15,
  ME: 15,
  MI: 15,
  MO: 15,
  MS: 15,
  MT: 15,
  ND: 15,
  NE: 15,
  OH: 15,
  OK: 15,
  OR: 15,
  PA: 15,
  SC: 15,
  SD: 15,
  TN: 15,
  UT: 15,
  VA: 15,
  VT: 15,
  WI: 15,
  WV: 15,
  WY: 15
};

export const coverageRSForcedAtXYearsAlwaysStates = {
  AR: 15
};

export const statesWithUniqueLogic = ['TX', 'OK'];
